import { Routes } from '@angular/router';
import { CalGuardService } from '@cvx/cal-angular';

import { MyCeRequests } from './pages/my-ce-requests/my-ce-requests';
import { MyCeRequestsAssigned } from './pages/my-ce-requests-assigned/my-ce-requests-assigned';
import { RequestsHomeComponent } from './pages/requests-home/requests-home';
import { ProjectTeamComponent } from './pages/project-team/project-team';
import { NewProjectComponent } from './pages/new-project/new-project';
import { ExistingProjectComponent } from './pages/existing-project/existing-project';
import { QuestionnaireComponent } from './pages/questionnaire/questionnaire';
import { ResponsePageComponent } from './pages/response-page/response-page';
import { ViewRequestComponent } from './pages/view-request/view-request';
import { AccessDeniedComponent } from './pages/access-denied/access-denied';
import { roleGuard } from './guards/role.guard';
import { projectEditStatusGuard } from './guards/project-edit-status.guard';
import { unsavedChangesGuard } from './guards/unsaved-changes.guard';

const APP_ALLOWED_ROLES = ['ce_engineer', 'ce_engineers', 'project_engineer', 'project_engineers', 'cet_admin'];

export const routes: Routes = [
  {
    path: '',
    component: RequestsHomeComponent,
    title: 'Requests',
    canActivate: [CalGuardService, roleGuard],
    data: {
      allowedRoles: APP_ALLOWED_ROLES,
      redirectTo: '/access-denied',
    },
  },
  {
    path: 'my-ce-requests-assigned',
    component: MyCeRequestsAssigned,
    title: 'Requests',
    canActivate: [CalGuardService, roleGuard],
    data: {
      allowedRoles: ['ce_engineer', 'ce_engineers', 'cet_admin'],
      redirectTo: '/access-denied',
    },
  },
  {
    path: 'project-team',
    component: ProjectTeamComponent,
    title: 'Project Team',
    canActivate: [CalGuardService, roleGuard, projectEditStatusGuard],
    data: {
      allowedRoles: APP_ALLOWED_ROLES,
      redirectTo: '/access-denied',
    },
  },
  {
    path: 'new-project',
    component: NewProjectComponent,
    title: 'New Project',
    canActivate: [CalGuardService, roleGuard, projectEditStatusGuard],
    data: {
      allowedRoles: APP_ALLOWED_ROLES,
      redirectTo: '/access-denied',
    },
  },
  {
    path: 'existing-project',
    component: ExistingProjectComponent,
    title: 'Existing Project',
    canActivate: [CalGuardService, roleGuard, projectEditStatusGuard],
    data: {
      allowedRoles: APP_ALLOWED_ROLES,
      redirectTo: '/access-denied',
    },
  },
  {
    path: 'questionnaire',
    component: QuestionnaireComponent,
    title: 'Questionnaire',
    canActivate: [CalGuardService, roleGuard, projectEditStatusGuard],
    canDeactivate: [unsavedChangesGuard],
    data: {
      allowedRoles: APP_ALLOWED_ROLES,
      redirectTo: '/access-denied',
    },
  },
  {
    path: 'response-page',
    component: ResponsePageComponent,
    title: 'Response Page',
    canActivate: [CalGuardService, roleGuard],
    data: {
      allowedRoles: APP_ALLOWED_ROLES,
      redirectTo: '/access-denied',
    },
  },
  {
    path: 'view-request',
    component: ViewRequestComponent,
    title: 'View Request',
    canActivate: [CalGuardService, roleGuard],
    data: {
      allowedRoles: APP_ALLOWED_ROLES,
      redirectTo: '/access-denied',
    },
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
    title: 'Access Denied',
    canActivate: [CalGuardService],
  },
  { path: '**', redirectTo: '' },
];
